import URL from './isomorphicURL';

export default function (originalUrl, languageCode, availableLanguageCodes) {
    try {
        const url = new URL(originalUrl);
        // skip first because "/en/part1".split('/') == ["", "en", "part1"]
        const [, urlLanguageSegment, ...pathsWithoutLanguage] = url.pathname.split('/');

        if (!availableLanguageCodes.includes(urlLanguageSegment)) {
            return originalUrl;
        }
        return `${url.origin}/${languageCode}/${pathsWithoutLanguage.join('/')}${url.search}`;
    } catch (error) {
        return originalUrl;
    }
}
